import React, { useState, useEffect, useRef, memo } from 'react';
import { AlertTriangle } from 'lucide-react';
import Button from '../../common/button/Button';

import styles from './styles/UnsavedChangesBar.module.css';

const UnsavedChangesBar = ({ onSave, onClear, isVisible, isSaving = false, saveError = null }) => {
    const [shouldRender, setShouldRender] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        if (isVisible && !shouldRender) {
            // Show with animation
            setShouldRender(true);
            setIsAnimating(true);
        } else if (!isVisible && shouldRender) {
            // Hide with animation
            setIsAnimating(true);
        }
    }, [isVisible, shouldRender]);

    const handleAnimationEnd = () => {
        setIsAnimating(false);
        if (!isVisible) {
            setShouldRender(false);
        }
    };

    if (!shouldRender) return null;

    const animationClass = isAnimating ? (isVisible ? styles.slideUp : styles.slideDown) : '';

    return (
        <div 
            ref={elementRef}
            className={`${styles.unsavedChangesBar} ${animationClass}`}
            onAnimationEnd={handleAnimationEnd}
        >
            <div className={styles.unsavedChangesContent}>
                <div className={styles.unsavedChangesMessage}>
                    <AlertTriangle size={16} className={styles.unsavedChangesIcon} />
                    <span className={styles.unsavedChangesText}>
                        {saveError ? `Error saving changes` : 'You have unsaved changes'}
                    </span>
                </div>
                <div className={styles.unsavedChangesActions}>
                    <Button onClick={onClear} variant="secondary" size="small" disabled={isSaving}>
                        Clear
                    </Button>
                    <Button onClick={onSave} variant="primary" size="small" disabled={isSaving}>
                        Save
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default memo(UnsavedChangesBar);
